export default __webpack_public_path__ + "static/media/uni.aef0cead.svg";